/*
 * Copyright (c) 2021 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Friday, October 1st 2021, 10:59:53 am
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import Skeleton, { SkeletonProps } from "@mui/material/Skeleton";
import Stack from "@mui/material/Stack";
import { Backdrop, Box, CircularProgressProps } from "@mui/material";
import { Responsive2ColGridContainer, Responsive2ColGridItem } from "ui-widgets";
import { OSCircularLoaderIcon } from "theme/icons";

type OSCircularProgressProps = { style?: React.CSSProperties } & CircularProgressProps;

export const OSCircularProgress = (props: OSCircularProgressProps) => (
  <OSCircularLoaderIcon className={props.className} style={props.style} />
);

export const CircularProgressInFront = () => {
  return (
    <Backdrop open={true} invisible={true}>
      <OSCircularProgress />
    </Backdrop>
  );
};

export const CircularProgressCentered = ({ height }: { height?: React.CSSProperties["height"] }) => {
  return (
    <Box
      sx={{
        position: "relative",
        height: height ?? "50vh",
      }}
    >
      <OSCircularProgress
        style={{
          position: "absolute",
          zIndex: 0,
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
        }}
      />
    </Box>
  );
};

export const SkeletonProgessLoader = (props: SkeletonProps) => {
  return (
    <Stack spacing={1}>
      <Skeleton {...props} />
    </Stack>
  );
};

export const FormSkeletonProgessLoader = (props: SkeletonProps) => {
  return (
    <Responsive2ColGridContainer>
      <Responsive2ColGridItem>
        <br />
        <Skeleton animation="wave" variant="rectangular" height={40} />
        <br />
        <Skeleton animation="wave" variant="rectangular" height={40} />
        <br />
        <Skeleton animation="wave" variant="rectangular" height={120} />
        <br />
        <Skeleton animation="wave" variant="rectangular" height={40} />
      </Responsive2ColGridItem>
      <Responsive2ColGridItem>
        <br />
        <Skeleton animation="wave" variant="rectangular" height={40} />
        <br />
        <Skeleton animation="wave" variant="rectangular" height={120} />
        <br />
        <Skeleton animation="wave" variant="rectangular" height={40} />
        <br />
        <Skeleton animation="wave" variant="rectangular" height={40} />
      </Responsive2ColGridItem>
    </Responsive2ColGridContainer>
  );
};

export const BackdropLoader = ({ open }) => {
  return (
    <div>
      <Backdrop sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }} open={open}>
        <OSCircularProgress color="inherit" />
      </Backdrop>
    </div>
  );
};
